export default __webpack_public_path__ + "static/media/LVZ WEB ICONS - SPEECH TO TEXT.73d5b8f6.svg";